// extracted by mini-css-extract-plugin
module.exports = {"header":"CopyFeature_header__3XVsQ","content":"CopyFeature_content__2KiGQ","text":"CopyFeature_text___3mt6"};